export enum RosterStatuses {
  Active = "ACTIVE",
  Injured = "INJURED",
  OtherNotParticipating = "OTHER_NOT_PARTICIPATING",
  Out = "OUT",
  Suspended = "SUSPENDED",
}
